import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import DrawerManager from "@components/Drawer/DrawerManager";
import { createModalToken } from "@components/Modal/ModalManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";

import { RegistryFormModalParams } from "./widgets/registry_form_modal_widget/types";

export const giftRegistryApplicationLoggerToken = Symbol(
    "giftRegistryApplicationLoggerToken"
) as InjectionToken<LoggerInterface>;

export const giftRegistryAuthApiClientToken = Symbol(
    "giftRegistryAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const giftCartDrawerManagerToken = Symbol(
    "giftCartDrawerManagerToken"
) as InjectionToken<DrawerManager>;

export const addToRegistryModalToken = createModalToken<{
    productId: number;
    variantId: number | null;
}>("AddToRegistryModal");

export const registryFormModalToken =
    createModalToken<RegistryFormModalParams>("RegistryFormModal");
